import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

export const authCanActivateGuard: CanActivateFn = (route, state) => inject(AuthService).isAuthenicated();
